'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var useDidUpdate = require('../hooks/useDidUpdate.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 30px;\n  width: 30px;\n  cursor: pointer;\n  background: #ffffff;\n  box-shadow: 0px 2px 5px rgba(216, 216, 216, 0.36);\n  border-radius: 50%;\n  transform: translate(-15px, -12.5px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:before {\n    position: absolute;\n    content: '", "';\n    font-weight: normal;\n    bottom: 35px;\n    font-size: 13px;\n    line-height: 20px;\n    color: #555555;\n    width: max-content;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  height: 5px;\n  border-radius: 4px;\n  background-color: #b8a3d7;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 5px;\n  position: relative;\n  border-radius: 4px;\n  background-color: #dddddd;\n  margin-top: 30px;\n  margin-bottom: 15px;\n  width: 280px;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = styled__default['default'].div(_templateObject(), index.styleEngine);
var Range = styled__default['default'].div(_templateObject2());
var Thumb = styled__default['default'].div(_templateObject3(), function (_ref) {
  var value = _ref.value;
  return value;
});

var HandleBar = function HandleBar() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "6",
    height: "14",
    viewBox: "0 0 6 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M1.49895 0.499638V12.5325",
    stroke: "#CCCCCC",
    strokeLinecap: "square"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M4.49701 0.499638V12.5325",
    stroke: "#CCCCCC",
    strokeLinecap: "square"
  }));
};

var Slider = function Slider(_ref2) {
  var variant = _ref2.variant,
      value = _ref2.value,
      step = _ref2.step,
      onChange = _ref2.onChange,
      getValue = _ref2.getValue,
      restProps = _objectWithoutProperties(_ref2, ["variant", "value", "step", "onChange", "getValue"]);

  var rangeOffset = variant === 'range' ? step : 0;

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      min = _useState2[0],
      setMin = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      max = _useState4[0],
      setMax = _useState4[1];

  var _useState5 = React.useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      dragEnd = _useState6[0],
      setDragEnd = _useState6[1];

  var slider = React.useRef();
  var leftThumb = React.useRef();
  var rightThumb = React.useRef();
  React.useEffect(function () {
    switch (variant) {
      case 'default':
        setMin(0);
        setMax(value);
        break;

      case 'inverse':
        setMin(100 - value);
        setMax(100);
        break;

      default:
        setMin(value[0]);
        setMax(value[1]);
        break;
    }
  }, []);
  useDidUpdate['default'](function () {
    if (dragEnd) {
      var _value;

      switch (variant) {
        case 'range':
          _value = [min, max];
          break;

        case 'default':
          _value = max;
          break;

        case 'inverse':
          _value = 100 - min;
          break;

        default:
          return;
      }

      onChange && onChange(_value);
    }
  }, [dragEnd]);

  var _onMouseDown = function onMouseDown(event, thumb) {
    // event.preventDefault()
    setDragEnd(false);
    var activeThumb;

    switch (thumb) {
      case 'left':
        activeThumb = leftThumb;
        break;

      case 'right':
        activeThumb = rightThumb;
        break;

      default:
        return;
    }

    var sliderWidth = slider.current.offsetWidth;
    var thumbOffset = event.clientX - activeThumb.current.getBoundingClientRect().left;

    var onMouseMove = function onMouseMove(e) {
      var value = e.clientX - thumbOffset - slider.current.getBoundingClientRect().left;

      if (value < 0) {
        value = 0;
      }

      if (value > sliderWidth) {
        value = sliderWidth;
      }

      var valuePercentage = Math.ceil(value / sliderWidth * 100 / step) * step;

      if (thumb === 'left') {
        setMin(parseInt(Math.min(valuePercentage, max - rangeOffset)));
      } else {
        setMax(parseInt(Math.max(valuePercentage, min + rangeOffset)));
      }
    };

    var onMouseUp = function onMouseUp() {
      setDragEnd(true);
      document.removeEventListener('mouseup', onMouseUp);
      document.removeEventListener('mousemove', onMouseMove);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  React.useEffect(function () {
    window.addEventListener('mousedown', _onMouseDown);
    return function () {
      window.removeEventListener('mousedown', _onMouseDown);
    };
  });
  return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({
    ref: slider
  }, restProps), /*#__PURE__*/React__default['default'].createElement(Range, {
    style: {
      left: "".concat(min, "%"),
      right: "".concat(100 - max, "%")
    }
  }), ['inverse', 'range'].includes(variant) ? /*#__PURE__*/React__default['default'].createElement(Thumb, {
    style: {
      left: "".concat(min, "%")
    },
    onMouseDown: function onMouseDown(event) {
      return _onMouseDown(event, 'left');
    },
    ref: leftThumb,
    value: getValue ? getValue(min) : min
  }, /*#__PURE__*/React__default['default'].createElement(HandleBar, null)) : null, ['default', 'range'].includes(variant) ? /*#__PURE__*/React__default['default'].createElement(Thumb, {
    style: {
      left: "".concat(max, "%")
    },
    onMouseDown: function onMouseDown(event) {
      return _onMouseDown(event, 'right');
    },
    ref: rightThumb,
    value: getValue ? getValue(max) : max
  }, /*#__PURE__*/React__default['default'].createElement(HandleBar, null)) : null);
};
Slider.propTypes = {
  variant: PropTypes__default['default'].oneOf(['default', 'inverse', 'range']),
  value: PropTypes__default['default'].oneOfType(PropTypes__default['default'].number, PropTypes__default['default'].array),
  step: PropTypes__default['default'].number,
  onChange: PropTypes__default['default'].func,
  getValue: PropTypes__default['default'].func
};
Slider.defaultProps = {
  variant: 'default',
  value: 0,
  step: 1
};

exports.Slider = Slider;
exports.default = Slider;
